
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/badge",
      function () {
        return require("private-next-pages/material-ui/api/badge.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/badge"])
      });
    }
  